import { ContentsState, request } from "@lu/request";
import { VideoUploadResult } from "@lu/video-library";

import { ServerEndpoint } from "../../../../server/router/http/endpoint";
import { uploadImageResponseDecoder, UploadVideoResponseDecoder } from "../decoders";

export const uploadImage = (url: string, file: File): Promise<ContentsState<string>> => {
	const data = new FormData();
	data.append("file", file);

	return request
		.postFormData(url, data, uploadImageResponseDecoder)
		.then(({ payload }) => {
			if (payload.state === "failed") console.error(payload.error);
			return payload;
		})
		.catch((error) => {
			console.error(error);

			throw error;
		});
};

export const uploadVideo = (file: File): Promise<ContentsState<VideoUploadResult>> => {
	const data = new FormData();
	data.append("file", file);

	return request
		.postFormData(ServerEndpoint.internal.video.base, data, UploadVideoResponseDecoder)
		.then(({ payload }) => {
			if (payload.state === "failed") console.error(payload.error);
			return payload;
		})
		.catch((error) => {
			console.error(error);

			throw error;
		});
};
